const indexItems = [
  {
    id: 1,
    title: '明星恋情追踪',
    count: '36篇',
    icon: 'ri-heart-line',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    id: 2,
    title: '综艺名场面',
    count: '28篇',
    icon: 'ri-emotion-laugh-line',
    color: 'bg-accent-50 text-accent-600',
  },
  {
    id: 3,
    title: '影视剧吐槽',
    count: '42篇',
    icon: 'ri-film-line',
    color: 'bg-secondary-50 text-secondary-600',
  },
  {
    id: 4,
    title: '网红风云录',
    count: '31篇',
    icon: 'ri-live-line',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    id: 5,
    title: '体育大事件',
    count: '25篇',
    icon: 'ri-basketball-line',
    color: 'bg-accent-50 text-accent-600',
  },
  {
    id: 6,
    title: '科技新动向',
    count: '19篇',
    icon: 'ri-smartphone-line',
    color: 'bg-secondary-50 text-secondary-600',
  },
  {
    id: 7,
    title: '海外热话题',
    count: '22篇',
    icon: 'ri-global-line',
    color: 'bg-primary-50 text-primary-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">专题合集</h2>
          <p className="text-foreground-600 text-sm md:text-base">按主题快速浏览，找到你感兴趣的吃瓜方向</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="flex items-center gap-3 bg-background-50 border border-background-200/60 rounded-xl p-4 hover:border-primary-200/50 hover:bg-primary-50/20 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.color} flex-shrink-0`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}